module.exports = __webpack_public_path__ + "img/piik.0a6d2a1a.png";